import React from 'react';
import { bool } from 'prop-types';
import { I18n } from '@fiverr-private/i18n-react';
import { Button } from '@fiverr-private/button';
import { ChevronDownIcon } from '@fiverr-private/visuals';
import { Stack } from '@fiverr-private/layout_components';

const TriggerButton = ({ isTransparent, isOpen }) => (
    <Button
        intent="secondary"
        variant="ghost"
        colorScheme={isTransparent ? 'white' : ''}
        backgroundColor={isTransparent ? 'transparent' : ''}
    >
        <Stack gap="1" alignItems="center" color={isTransparent ? 'white' : 'grey_1000'}>
            <I18n k="resources_tab.title" />
            <Stack transform={isOpen ? 'rotate(180deg)' : 'none'} transition="0.15s ease-in-out">
                <ChevronDownIcon size="md" color={isTransparent ? 'white' : undefined} />
            </Stack>
        </Stack>
    </Button>
);

TriggerButton.propTypes = {
    isTransparent: bool,
    isOpen: bool,
};

export default TriggerButton;
